import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { PLANES } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-ink-soft px-5 py-16 sm:px-8 sm:py-24" data-id="element-119" data-mp="2oifqt3w5ci6k">
      <div className="mx-auto max-w-5xl" data-id="element-120" data-mp="2jjmdpckrut6x">
        <div className="text-center" data-id="element-121" data-mp="2jknu7wkk47w1">
          <SectionLabel data-id="element-122" data-mp="2jlpcakzzpun9">Elegí tu pack</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-123" data-mp="1vv37d2la8qhh">
            Empezá en 5 minutos
          </h2>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-124" data-mp="1rut2jt988647">
          {PLANES.map(plan => <article key={plan.titulo} className={`relative flex h-full flex-col rounded-3xl border bg-ink p-7 sm:p-8 ${plan.destacado ? 'border-violeta-500' : 'border-ink-line'}`} data-id="element-125" data-mp="25pv4k5aydbbq">
              {plan.destacado && <span className="absolute -top-3 left-7 rounded-full bg-violeta-500 px-3 py-1 font-display text-[10px] font-bold uppercase tracking-[0.18em] text-white" data-id="element-126" data-mp="3cae6e02mozpi">
                  Más elegido
                </span>}
              <p className="font-display text-[10px] font-semibold uppercase tracking-[0.28em] text-violeta-300" data-id="element-127" data-mp="9rpblovh35w7">
                {plan.eyebrow}
              </p>
              <h3 className="mt-3 font-display text-3xl font-extrabold text-white" data-id="element-128" data-mp="ep8vp5euqcw2">
                {plan.titulo}
              </h3>
              <p className="mt-3 text-sm text-violeta-100/70" data-id="element-129" data-mp="3i7ipdvyf639k">{plan.bajada}</p>

              <p className="mt-6 text-sm text-violeta-100/50 line-through" data-id="element-130" data-mp="3n755cd5mtxm2">{plan.valorReal}</p>
              <p className="mt-1 font-display text-4xl font-extrabold text-violeta-300 sm:text-5xl" data-id="element-131" data-mp="3rxv8djql5odl">
                {plan.precio}
                <span className="ml-2 align-middle text-base font-semibold text-violeta-100/70" data-id="element-132" data-mp="2uj9a7cvpodre">
                  ARS
                </span>
              </p>

              <ul className="mt-7 flex-1 space-y-3" data-id="element-133" data-mp="2zf7tim26n5ky">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-2.5 text-sm text-violeta-100" data-id="element-134" data-mp="2mhruttlpjq5r">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-violeta-400" aria-hidden="true" data-id="element-135" data-mp="316obgf1tybhz" />
                    {feature}
                  </li>)}
              </ul>

              <a href={plan.url} className={`mt-8 inline-flex w-full items-center justify-center rounded-full px-6 py-4 font-display text-sm font-bold transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violeta-300 sm:text-base ${plan.destacado ? 'bg-violeta-500 text-white hover:bg-violeta-400' : 'border border-violeta-400/60 text-violeta-100 hover:border-violeta-300 hover:text-white'}`} data-id="element-136" data-mp="28iiqbr6v6khm">
                {plan.cta}
              </a>
            </article>)}
        </div>

        <p className="mt-8 text-center text-xs text-violeta-100/70 sm:text-sm" data-id="element-137" data-mp="5artsaol57i3">
          🔒 Pago seguro · ⚡ 5 min · 💳 Mercado Pago | Tarjeta | Transferencia
        </p>

        <div className="mt-10 flex flex-col items-start gap-4 rounded-3xl border border-ink-line bg-ink p-7 sm:flex-row sm:items-center sm:gap-6" data-id="element-138" data-mp="3rhq255g1m6yx">
          <ShieldCheckIcon className="h-10 w-10 shrink-0 text-violeta-400" aria-hidden="true" data-id="element-139" data-mp="j37qktqw89ak" />
          <div data-id="element-140" data-mp="a934soqm9o1w">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-141" data-mp="a7ian087s74k">
              Garantía 7 días — Sin preguntas
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-violeta-100/75" data-id="element-142" data-mp="e8bu9hemizrn">
              Si en 7 días no es lo que esperabas — devolución del 100% sin formularios ni drama.
              Escribís a{' '}
              <a href="mailto:soportetubrujuladigital@gmail.com" className="font-semibold text-violeta-300 underline decoration-violeta-600 underline-offset-2" data-id="element-143" data-mp="16sk94k841tpj">
                soportetubrujuladigital@gmail.com
              </a>{' '}
              y listo. Tasa de devoluciones: menos del 1%.
            </p>
            <p className="mt-3 text-xs font-semibold text-violeta-300" data-id="element-144" data-mp="318so8uef810q">
              ✓ Garantía real · 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}